window.goToPage = function (el) {
    const item = document.getElementById(el.id);
    const selectedVal = item.options[item.selectedIndex];
    const url = selectedVal.getAttribute('data-url');
    if (url) {
        window.location = url;
    }
};
